import type { Theme } from '../../themes/themes';

export const createButtonGroupFieldTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          display: 'flex',
          backgroundColor: 'transparent',
          gap: 0,
        },
        grouped: {
          transition: 'none',
          color: theme.palette.labeling.secondaryDefault,
          border: `1px solid ${theme.palette.border.secondaryDefault}`,
          backgroundColor: theme.palette.surface.secondaryDefault,
          flexGrow: 1,

          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4),

          paddingLeft: theme.spacing(5),
          paddingRight: theme.spacing(5),

          [theme.breakpoints.up('lg')]: {
            paddingTop: theme.spacing(5),
            paddingBottom: theme.spacing(5),
          },

          '&:hover': {
            boxShadow: 'none',
            color: theme.palette.labeling.secondaryHover,
            borderColor: theme.palette.border.secondaryHover,
            backgroundColor: theme.palette.surface.secondaryHover,
          },
          '&:active': {
            boxShadow: 'none',
            backgroundColor: theme.palette.surface.secondaryActive,
            borderColor: theme.palette.border.secondaryActive,
            color: theme.palette.labeling.secondaryActive,
          },
          '&[aria-checked=true]': {
            borderColor: theme.palette.surface.positive,
            backgroundColor: theme.palette.surface.positive,
            color: theme.palette.labeling.defaultInverted,
          },
          ':first-of-type': {
            borderTopLeftRadius: theme.spacing(12),
            borderBottomLeftRadius: theme.spacing(12),
            borderRightWidth: '0',
          },
          ':last-of-type': {
            borderTopRightRadius: theme.spacing(12),
            borderBottomRightRadius: theme.spacing(12),
            ':not(:nth-child(2))': {
              borderLeftWidth: '0',
            },
          },
          '&:focus-visible': {
            transition: 'none',
            borderLeftWidth: '1px',
            borderRightWidth: '1px',
            boxShadow: '0 0 0 2px #FFF',
            outline: `2px solid ${theme.palette.border.defaultFocus}`,
            outlineOffset: '2px',
            zIndex: 1,
          },
        },
      },
      defaultProps: {
        disableElevation: true,
        disableFocusRipple: true,
        disableRipple: true,
      },
    },
  },
});
